const Modules = {
  Session: 'Session',
  Sequence: 'Sequence',
  List: 'Lists',
  'Target Account': 'Target Account',
  'Target Contact': 'Target Contact',
  'Database Accounts': 'Database accounts',
  'Database Contacts': 'Database contacts',
  Settings: 'Settings',
  'Website Reveal Accounts': 'Website Reveal Accounts',
  'Website Reveal Contacts': 'Website Reveal Contacts',
  'Account ICP': 'Account ICP',
  'Champions Tracking': 'Champions Tracking',
};

export default Modules;
